import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=1c895b51&"
import script from "./Checkout.vue?vue&type=script&lang=ts&"
export * from "./Checkout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports